import { render, staticRenderFns } from "./AgotadoInfo.vue?vue&type=template&id=3c1de5e2&"
import script from "./AgotadoInfo.vue?vue&type=script&lang=js&"
export * from "./AgotadoInfo.vue?vue&type=script&lang=js&"
import style0 from "./AgotadoInfo.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports